// eslint-disable-next-line import/no-extraneous-dependencies
import Vue from 'vue'
import { firestore } from 'firebase'
import { contains } from 'ramda'
import {
  Module, VuexModule, Mutation, Action,
} from 'vuex-module-decorators'
import { firestoreAction } from 'vuexfire'
import { NotificationType } from '../../types'
import { db } from '../../firebase/init'
import store from '..'

const serializeId = (snapshot: firestore.DocumentSnapshot) => {
  const data: any = snapshot.data()
  data.id = snapshot.id
  return data
}

@Module({ name: 'location', store, dynamic: true })
export default class extends VuexModule {
  data: any = {}

  notifications: NotificationType[] = []

  checkNames: string[] = []

  gData: any = {}

  locationSet: boolean = false

  couponTemplates = []

  get allShifts () {
    if (!this.data.shifts) return []
    return this.data.shifts
  }

  get locationName () {
    if (!this.data || !this.data.name) return ''
    return this.data.name
  }

  get allNotifications () {
    if (!this.notifications || this.notifications.length === 0) return []
    return this.notifications
  }

  get location () {
    if (!this.data) return null
    return this.data.id
  }

  get group () {
    return this.data.group ? this.data.group : ''
  }

  get shifts () {
    return this.allShifts || []
  }

  get newNotifications () {
    console.log('lastViewed: ', store.getters.userDbInfo.lastNotification)
    // @ts-ignore
    return this.allNotifications.filter((notification: NotificationType) => notification.created.seconds * 1000 > store.getters.userDbInfo.lastNotification)
  }

  @Mutation
  makeLocationSet (x: boolean) {
    this.locationSet = x
  }

  @Action
  async bindNotifications () {
    console.log('binding notifications: ', [this.data.id, this.data.group])
    const bindNotes = firestoreAction(({ bindFirestoreRef }) => bindFirestoreRef('notifications', db.collection('notifications').where('location', 'in', [this.data.id, this.data.group]).orderBy('created', 'desc').limit(5))) as Function
    return bindNotes(this.context)
  }

  @Action
  async bindGroup () {
    console.log('binding group: ', [this.data.id, this.data.group])
    const bindGroup = firestoreAction(({ bindFirestoreRef }) => bindFirestoreRef('gData', db.collection('groups').doc(this.data.group))) as Function
    return bindGroup(this.context)
  }

  @Action
  async bindCouponTemplates () {
    console.log('binding group: ', [this.data.id, this.data.group])
    const bindTemplates = firestoreAction(({ bindFirestoreRef }) => bindFirestoreRef('couponTemplates', db.collection('couponTemplates').where('group', '==', this.data.group))) as Function
    return bindTemplates(this.context)
  }

  @Action
  async bindLocation (id: string) {
    // if (id === 'cobbsmchenry') return null
    window.localStorage.setItem('lastLocation', id)
    console.log('makin')
    this.makeLocationSet(true)
    const bindLocation = firestoreAction(({ bindFirestoreRef }) => bindFirestoreRef('data', db.doc(`locations/${id}`), { serialize: serializeId, wait: true })) as Function
    return bindLocation(this.context)
  }
}

// , JC9D3EVBz
